import React from "react";
import Button from "../../../Common/Buttons/Button";
import UserImg from "../../../Common/User/UserImg";
import { LoginForm, type LoginFormRef } from "../Form/LoginForm";
import { type LoginUserType } from "./LoginUser";

type Props = {
    hidden: boolean;
    user: null | LoginUserType;
    password: string;
    username: string;
    touchNumbers: boolean;
    requirePassword: boolean;
    onChange: (name: string, value: string) => void;
    onLogin: () => Promise<void>;
    onClock: () => Promise<void>;
    onCancel: () => void;
};

type State = {
    user: null | LoginUserType;
};

export default class LoginUserForm extends React.Component<Props, State> {
    public loginFormRef = React.createRef<LoginFormRef>();

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = {
            user: props.user,
        };
    }

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        if(prevProps.user !== this.props.user && this.props.user) {
            this.setState({
                user: this.props.user,
            });
        }
    }

    public handleTransitionEnd = (e: React.TransitionEvent<HTMLDivElement>): void => {
        if(e.target === e.currentTarget) {
            if(this.props.user !== null) {
                this.loginFormRef.current?.focus();
            }

            this.setState({
                user: this.props.user,
            });
        }
    };

    public render(): React.ReactNode {
        return (
            <div
                className={"login-user-form" + (this.props.hidden ? " hidden" : "")}
                onTransitionEnd={this.handleTransitionEnd}
            >
                {this.state.user && (
                    <React.Fragment>
                        <div className="login-user-image">
                            <UserImg url={this.state.user.image} />
                        </div>
                        <div className="login-user-name">
                            {this.state.user.name}
                        </div>
                        <LoginForm
                            ref={this.loginFormRef}
                            username={this.props.username}
                            password={this.props.password}
                            onChange={this.props.onChange}
                            onLogin={this.props.onLogin}
                            onClock={this.props.onClock}
                            touchNumbers={this.props.touchNumbers}
                            requirePassword={this.props.requirePassword}
                        />
                        <div className="login-user-cancel" >
                            <Button
                                classes={[ "button-cancel" ]}
                                onClick={this.props.onCancel}
                            >
                                Cancel
                            </Button>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}
